import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hint-card',
  imports: [TranslateModule],
  templateUrl: './hint-card.component.html',
  styleUrls: ['./hint-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HintCardComponent {
  private readonly translate = inject(TranslateService);

  @Input() titleKey = '';
  @Input() iconName = '';
  @Input() iconWidth = 20;
  @Input() iconHeight = 20;

  @Input() set textKey(key: string) {
    if (!key) return;
    const resolved = this.translate.instant(key);
    this.textPages = Array.isArray(resolved) ? resolved : [resolved];
    this.totalPages = this.textPages.length;
    this.currentPage = 0;
    this.showPagination = this.totalPages > 1;
    this.currentText = this.textPages[0];
  }

  @Output() closed = new EventEmitter<void>();

  protected textPages: string[] = [];
  protected totalPages = 1;
  protected currentPage = 0;
  protected showPagination = false;
  protected currentText = '';

  protected prevPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.currentText = this.textPages[this.currentPage];
    }
  }

  protected nextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.currentText = this.textPages[this.currentPage];
    }
  }
}
